import { render, staticRenderFns } from "./bactadi.vue?vue&type=template&id=69738af0&scoped=true"
import script from "./bactadi.vue?vue&type=script&lang=js"
export * from "./bactadi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69738af0",
  null
  
)

export default component.exports